export const errorMessage = {
  isEmpty: " is required",
  isAdded: " is not added",
  isTrueValue: "Subscription is required",
  invalidEmail: "Please enter a valid email ID",
  passwordContainsSpace: "Please enter a valid password",
  invalidPassword:
    "Password should be 8 - 16 characters long and should contain one number, one uppercase letter, one lowercase letter, and one special symbol",
  invalidChars: "Please enter a valid ",
  invalidDigits: "Please enter a valid ",
  invalidDate: "End Date should be equal or greater than Start Date",
  invalidStartDate: "Start Date should not be greater than current date",
  passwordMismatch: "Password and Confirm password should be same",
  skillsSet: "Skills should be minimum 5 and maximum 10",
  invalidVerficationCode: "Please enter a valid verification code",
  slotTimeOverlapped: "Time slots should not be overlapped",
  slotTimeMismatch: "Time slots start time should not be greater than end time",
  invalidWeekDays: "Please select atleast one working day",
  invalidAcceptUntil: "Please select start date and end date",
  selectDocument: "Please select document",
  invalidDocStartDate: "Start date should not be greater than end date",
  invalidFees: "Please enter a valid fees",
  invalidZipcode: "Please enter a valid zipcode",
  noSlots: "No slots created",
  slotsEmpty: "Please select atleast one slot",
  slotsDataEmpty: "Please select slot data",
  invalidDEA: "Please enter a valid DEA Number",
  scheduleInvalid: "Please select unavailability schedule",
  validAge: "Age should be grater than 18",
  invalidFax: "Please enter a primary fax number ",
  charLength: "The field Address1 must be string with a maximum length of 35",
  createProfileDebugError: "Debug error create profile.",
  creatingProfileError: "Error occured while creating "
};
